import { computed, Injectable, signal } from "@angular/core";
import { User } from "../Dto/UserModel";
import { AuthStateModel } from "../Dto/AuthStateModel";
import { LoginResponse } from "../Dto/LoginResponse";
import { MeResponse } from "../Dto/MeResponse";

const initialState: AuthStateModel = {
  user: null,
  accessToken: null,
  refreshToken: null,
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class AuthState {
  private readonly state = signal<AuthStateModel>(initialState);

  public readonly user = computed(() => this.state().user);
  public readonly accessToken = computed(() => this.state().accessToken);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);
  public readonly isAuthenticated = computed(() => !!this.state().accessToken);

  setLoggedIn(response: LoginResponse) {
    this.state.update((state) => ({
      ...state,
      accessToken: response.accessToken,
      refreshToken: response.refreshToken,
      error: null,
    }));
    localStorage.setItem("accessToken", response.accessToken);
    localStorage.setItem("refreshToken", response.refreshToken);
  }

  setUser(response: MeResponse) {
    this.state.update((state) => ({
      ...state,
      user: response.user,
      error: null,
    }));
  }

  setLoggedOut() {
    this.state.set(initialState);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }

  setLoading(loading: boolean) {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null) {
    this.state.update((state) => ({ ...state, error }));
  }

  updateUser(userUpdate: Partial<User>) {
    this.state.update((state) => {
      if (!state.user) {
        return state;
      }

      return {
        ...state,
        user: {
          ...state.user,
          ...userUpdate,
        },
      };
    });
  }
}
